module.exports = __webpack_public_path__ + "static/media/portal-exit.0726d504.svg";